import { Component, h, Prop, State, Event, EventEmitter, Element, Listen } from "@stencil/core"
import { debounce } from "../../utils/utils"

@Component({
  tag: "ai12z-input-form",
  styleUrls: ["./input.css"],
  shadow: false,
  // scoped: true
})
export class InputForm {
  private searchFormElem: HTMLDivElement
  private searchInputElem: HTMLTextAreaElement
  // private searchTextareaElem: HTMLTextAreaElement
  private followUpElem: HTMLInputElement
  private uploadElem: HTMLInputElement
  private menuElem: HTMLElement
  // private customWidth = "100%"
  // private icon_width: string
  // private icon_height: string
  imagesBase64List = []

  @Element() el!: HTMLElement

  @Prop() isChat: boolean
  @Prop() placeholder: string
  @Prop() buttonText: string
  @Prop() followUpLabel: string
  @Prop() iconSrc: string
  @Prop() isImageUpload: boolean
  @Prop() isEnableMic: boolean
  @Prop() componentType: string = "search"

  @Event() action: EventEmitter

  @State() searchInput: string = ""
  @State() submitted: boolean = false
  @State() showErrorMessage: boolean = false
  @State() hideAllButtons: boolean = false
  @State() isOpen: boolean = false
  @State() capturedFile: File | null = null

  adjustHeight = () => {
    this.searchInputElem.style.height = "auto"
    this.searchInputElem.style.height = this.searchInputElem.scrollHeight + "px"
  }

  handleInputChange = (e: Event) => {
    this.searchInput = this.searchInputElem.value
    if (this.isChat) {
      return
    }
    // console.log("handleInputChange", this.searchInputElem.value)
    const value = this.searchInputElem.value
    if (value.length > 3 && !this.isChat) {
      this.action.emit({ event: e, value: value, type: "search", imgFiles: this.imagesBase64List })
    }
  }

  handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement
    if (this.isOpen && this.menuElem && !this.menuElem.contains(target)) {
      this.isOpen = false
    }
  }

  disconnectedCallback() {
    // console.log("disconnectedCallback input.tsx")
    // Clean up event listeners to avoid memory leaks
    document.removeEventListener("click", this.handleClickOutside)
    // Remove any other cleanup logic if necessary
  }

  componentDidLoad() {
    // console.log("componentWillLoad input.tsx")
    if (!this.isImageUpload) return
    const preivewContainer = this.el.querySelector(".custom-input")

    preivewContainer.addEventListener("paste", e => {
      e.stopPropagation()
      e.preventDefault()
      if (e["clipboardData"] && e["clipboardData"].getData("text")) {
        this.searchInput = e["clipboardData"].getData("text")
        return
      }
      const items = (e["clipboardData"] || window["clipboardData"]).files
      this.uploadImage(items)
    })
    preivewContainer.addEventListener("dragenter", e => {
      e.preventDefault()
      e.target["style"]["border"] = "1px dashed #000"
      // console.log("dragenter event")
    })
    preivewContainer.addEventListener("dragover", e => {
      e.preventDefault()
      e.target["style"]["border"] = "1px dashed #000"
      // console.log("dragover event")
    })
    preivewContainer.addEventListener("drop", e => {
      e.preventDefault()
      e.target["style"]["border"] = "none"
      // console.log('drop event', e['dataTransfer'].files);
      this.uploadImage(e["dataTransfer"].files)
    })

    document.addEventListener("click", this.handleClickOutside)
  }

  handleFormSubmit = (e: Event) => {
    e.preventDefault()
    if (this.searchInput.length > 3) {
      this.action.emit({ event: e, value: this.searchInputElem.value, type: "search" })
    }
  }

  @Listen("stateChanged", { target: "document" })
  stateChangedHandler(_state) {
    this.submitted = false
    if (this.isChat) {
      this.searchInputElem.value = ""
      this.searchInput = ""
      const parent = this.el.querySelector("#previewContainer")
      const textarea = this.el.querySelector("#searchInput")
      // textarea["style"].height = "20px"
      textarea["style"].overflow = "hidden"
      if (parent) {
        parent.innerHTML = ""
      }
      this.imagesBase64List = []
    }
  }

  @Listen("clearInput", { target: "document" })
  clearInputHandler(_state) {
    this.submitted = false
    this.searchInput = ""

    const parent = this.el.querySelector("#previewContainer")
    if (parent) {
      parent.innerHTML = ""
    }
    this.imagesBase64List = []
    this.searchInputElem.style.height = "auto"
  }

  handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Enter" && event.shiftKey) {
      console.log("Shift + Enter detected")
      // Prevent default behavior if needed
    }
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.handleAskAI(event)
    }
  }

  handleFollowUp = (e: Event) => {
    this.action.emit({ event: e, value: this.searchInputElem.value, imgFiles: this.imagesBase64List, type: "follow-up", followUp: false /*this.followUpElem.checked*/ })
  }

  handleAskAI = (e: Event) => {
    e.preventDefault()
    this.submitted = true
    this.showErrorMessage = false
    this.action.emit({ event: e, value: this.searchInputElem.value, imgFiles: this.imagesBase64List, followUp: this.followUpElem?.checked ?? false, type: "ask-ai" })
  }

  onInputChange(files: FileList) {
    this.showErrorMessage = false
    if (files.length > 0) {
      this.uploadImage(files)
    } else {
      console.error(files.length === 0 || "NO IMAGE UPLOADED")
      return false
    }
  }

  private uploadImage(files) {
    let newFile
    let tempImagesBase64List = []
    if (files.length > 10 || this.imagesBase64List.length > 10) {
      this.showErrorMessage = true
      // console.error('You can upload a maximum of 10 images once at a time.');
      return
    }
    for (var i = 0; i < files.length; i++) {
      const mimeType = files[i].type
      if (!mimeType.match("image.*")) {
        // console.log("file is not an image")
        return
      }
      newFile = files[i]

      const reader = new FileReader()

      reader.onload = () => {
        const imagePreviewContainer: HTMLElement = this.el.querySelector("#previewContainer")

        const base64Image = `data:${mimeType};base64,${(reader.result as string).split(",")[1]}`
        this.imagesBase64List.push(base64Image)
        tempImagesBase64List = this.imagesBase64List

        const newDiv = document.createElement("div")
        newDiv.classList.add("image-Container")
        newDiv.classList.add("sc-ai12z-input-form")

        const img = document.createElement("img")
        img.setAttribute("src", reader.result as string)
        img.style.width = "70px"
        img.style.height = "50px"
        img.style.borderRadius = ".75rem"

        const deleteSpan = document.createElement("span")
        deleteSpan.textContent = "x"
        deleteSpan.classList.add("delete-image")
        deleteSpan.classList.add("sc-ai12z-input-form")
        imagePreviewContainer.appendChild(newDiv)

        newDiv.appendChild(img)
        newDiv.appendChild(deleteSpan)

        deleteSpan.onclick = event => {
          let imgSrc = event.target["previousSibling"] ? event.target["previousSibling"].src : null
          let index = tempImagesBase64List.indexOf(imgSrc)
          if (index > -1) {
            tempImagesBase64List.splice(index, 1)
          }

          if (tempImagesBase64List.length < 10) {
            this.showErrorMessage = false
          }
          newDiv.remove()
        }

        // console.log('uploading finished, emitting an image blob to the outside world');
      }
      reader.readAsDataURL(newFile)
      reader.onloadend = () => {
        // console.log("upload finished")
      }

      reader.onerror = err => {
        console.error("something went wrong...", err)
      }
    }
  }

  toggleBox = e => {
    e.stopPropagation()
    this.isOpen = !this.isOpen
  }

  async captureScreen() {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: true, // Capture the screen
      })

      const video = document.createElement("video")
      video.srcObject = stream
      video.autoplay = true
      document.body.appendChild(video) // Add temporarily to allow rendering
      // // Ensure the page stays in focus
      // document.body.focus()

      await new Promise(resolve => (video.onloadedmetadata = resolve))

      // Ensure the video is playing before capturing
      await new Promise(resolve => setTimeout(resolve, 500))
      const canvas = document.createElement("canvas")
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      const ctx = canvas.getContext("2d")

      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
        // Convert canvas to Blob
        canvas.toBlob(blob => {
          if (blob) {
            const file = new File([blob], `screenshot-${Date.now()}.png`, { type: "image/png" })
            this.capturedFile = file

            // console.log("Captured File:", file)
            this.uploadImage([file]) // Call the uploadImage method with the captured file
          }
        }, "image/png")
      }

      // Stop video stream after capture
      stream.getTracks().forEach(track => track.stop())
      // Remove the video element from the DOM
      document.body.removeChild(video)
    } catch (err) {
      console.error("Error capturing screen:", err)
    }
  }

  render() {
    //To get the query params of the iconSrc
    // if (this.iconSrc) {
    //   const url = new URL(this.iconSrc)
    //   this.icon_width = url.searchParams.get("w") || "28"
    //   this.icon_height = url.searchParams.get("h") || "28"
    // }

    return (
      // <form onSubmit={this.handleFormSubmit}>
      //   <div ref={el => (this.searchFormElem = el)} class="input-container">
      //     {/* {this.isImageUpload && !this.hideAllButtons && (
      //       <div class="custom-attachment">
      //         <div class="image-upload__edit">
      //           <input
      //             type="file"
      //             multiple
      //             name="files[]"
      //             id="fileInput"
      //             accept="image/*"
      //             class="image-upload__input"
      //             onChange={($event: any) => this.onInputChange($event.target.files)}
      //             ref={el => (this.uploadElem = el as HTMLInputElement)}
      //           />
      //           <svg onClick={() => this.uploadElem.click()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20">
      //             <path
      //               d="M12,23l.218,0A7.183,7.183,0,0,0,19,15.749V4a1,1,0,0,0-2,0V15.749A5.171,5.171,0,0,1,12.154,21,5,5,0,0,1,7,16V6a3,3,0,0,1,6,0V16a1,1,0,0,1-2,0V8A1,1,0,0,0,9,8v8a3,3,0,0,0,6,0V6A5,5,0,0,0,5,6V16a7,7,0,0,0,7,7Z"
      //               fill="#000000"
      //               class="color000 svgShape"
      //             ></path>
      //           </svg>
      //         </div>
      //       </div>
      //     )} */}
      //     {this.isImageUpload && !this.hideAllButtons && (
      //       <div class="relative inline-block custom-attachment" style={{ width: "5%" }}>
      //         {/* Plus Button */}
      //         {!this.hideAllButtons && (
      //           <button class="w-8 h-8 text-blue-500" onClick={this.toggleBox}>
      //             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="20" height="20">
      //               <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"></path>
      //             </svg>
      //           </button>
      //         )}

      //         {/* Option Box */}
      //         <div
      //           class={`absolute bottom-12 left-0 w-40 bg-white rounded-lg shadow-lg transition-all duration-300 ease-in-out
      //     ${this.isOpen ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-90 pointer-events-none"}`}
      //         >
      //           <ul class="space-y-2">
      //             {/* <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex">
      //                       <div class="mr-1">
      //                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      //                           <path d="M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z"></path>
      //                           <path
      //                             fill-rule="evenodd"
      //                             d="M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
      //                             clip-rule="evenodd"
      //                           ></path>
      //                         </svg>
      //                       </div>
      //                       <div>Capture</div>
      //                     </li> */}
      //             <li
      //               class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
      //               onClick={() => {
      //                 this.uploadElem.click()
      //                 this.isOpen = false
      //               }}
      //             >
      //               <input
      //                 type="file"
      //                 multiple
      //                 name="files[]"
      //                 id="fileInput"
      //                 accept="image/*"
      //                 class="image-upload__input"
      //                 onChange={($event: any) => this.onInputChange($event.target.files)}
      //                 ref={el => (this.uploadElem = el as HTMLInputElement)}
      //               />
      //               <div class="mr-1">
      //                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 shrink-0">
      //                   <path
      //                     fill-rule="evenodd"
      //                     clip-rule="evenodd"
      //                     d="M18.0322 5.02393C17.7488 5.00078 17.3766 5 16.8 5H11.5002C11.3 6 11.0989 6.91141 10.8903 7.85409C10.7588 8.44955 10.6432 8.97304 10.3675 9.41399C10.1262 9.80009 9.80009 10.1262 9.41399 10.3675C8.97304 10.6432 8.44955 10.7588 7.85409 10.8903C7.81276 10.8994 7.77108 10.9086 7.72906 10.9179L5.21693 11.4762C5.1442 11.4924 5.07155 11.5001 5 11.5002V16.8C5 17.3766 5.00078 17.7488 5.02393 18.0322C5.04612 18.3038 5.0838 18.4045 5.109 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.59546 18.9162 5.69617 18.9539 5.96784 18.9761C6.25118 18.9992 6.62345 19 7.2 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H7.16144C6.6343 21 6.17954 21 5.80497 20.9694C5.40963 20.9371 5.01641 20.8658 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3.13419 18.9836 3.06287 18.5904 3.03057 18.195C2.99997 17.8205 2.99998 17.3657 3 16.8385L3 11C3 8.92477 4.02755 6.93324 5.4804 5.4804C6.93324 4.02755 8.92477 3 11 3L16.8385 3C17.3657 2.99998 17.8205 2.99997 18.195 3.03057C18.5904 3.06287 18.9836 3.13419 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C20.8658 5.01641 20.9371 5.40963 20.9694 5.80497C21 6.17954 21 6.6343 21 7.16144V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V7.2C19 6.62345 18.9992 6.25118 18.9761 5.96784C18.9539 5.69617 18.9162 5.59546 18.891 5.54601C18.7951 5.35785 18.6422 5.20487 18.454 5.109C18.4045 5.0838 18.3038 5.04612 18.0322 5.02393ZM5.28014 9.41336L7.2952 8.96556C8.08861 8.78925 8.24308 8.74089 8.35381 8.67166C8.48251 8.59121 8.59121 8.48251 8.67166 8.35381C8.74089 8.24308 8.78925 8.08861 8.96556 7.2952L9.41336 5.28014C8.51014 5.59289 7.63524 6.15398 6.89461 6.89461C6.15398 7.63524 5.59289 8.51014 5.28014 9.41336ZM17 15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15Z"
      //                     fill="currentColor"
      //                   ></path>
      //                 </svg>
      //               </div>
      //               <div>Upload Files</div>
      //             </li>
      //           </ul>
      //         </div>
      //       </div>
      //     )}
      //     {/* <div class="custom-attachment" style={{ width: this.hideAllButtons ? "100%" : "5%" }}>
      //       {/* <ai12z-mic></ai12z-mic> */}
      //     {/* <audio-recorder
      //         component-type="search"
      //         onStartRecord={_ev => {
      //           // console.log("test", ev)
      //           this.hideAllButtons = true
      //         }}
      //         onStopRecord={_ev => {
      //           this.hideAllButtons = false
      //         }}
      //         onSendTranscript={ev => {
      //           console.log("ev", ev)

      //           setTimeout(() => {
      //             console.log("input", this.searchInputElem)
      //             if (this.searchInputElem) {
      //               this.searchInputElem.value = ev.detail
      //               this.adjustHeight
      //             }
      //           }, 1000)
      //         }}
      //         style={{ width: "100%" }}
      //       ></audio-recorder>
      //     </div> */}

      //     {!this.hideAllButtons && (
      //       <div class="inner-container">
      //         <div id="previewContainer" draggable></div>
      //         <textarea
      //           readOnly={this.submitted}
      //           id="searchInput"
      //           ref={el => {
      //             this.searchInputElem = el as HTMLTextAreaElement
      //             el?.focus()
      //           }}
      //           required
      //           placeholder={this.placeholder}
      //           autoComplete="off"
      //           class="custom-input"
      //           value={this.searchInput}
      //           rows={1}
      //           onInput={debounce(e => this.handleInputChange(e), 500)}
      //           onKeyUp={this.adjustHeight}
      //           onKeyDown={this.handleKeyDown}
      //           onFocus={() => this.searchFormElem.classList.add("input-focus-color")}
      //           onBlur={() => this.searchFormElem.classList.remove("input-focus-color")}
      //         ></textarea>
      //       </div>
      //     )}
      //     {!this.hideAllButtons && (
      //       <button disabled={this.submitted} onClick={this.handleAskAI} class="ai-button">
      //         <img src={this.iconSrc} alt="Mountain" class={{ "hide-svg": this.iconSrc === "" || this.submitted }} width={this.icon_width} height={this.icon_height}></img>
      //         {this.submitted && (
      //           <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      //             <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      //             <path
      //               class="opacity-75"
      //               fill="currentColor"
      //               d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      //             ></path>
      //           </svg>
      //         )}
      //         <span>{this.buttonText} </span>
      //       </button>
      //     )}
      //   </div>
      //   {this.showErrorMessage && <p class="error-msg">You can upload a maximum of 10 images once at a time.</p>}
      //   {this.isChat && (
      //     <div class="follow-up">
      //       <input
      //         ref={el => (this.followUpElem = el as HTMLInputElement)}
      //         type="checkbox"
      //         name="followUp"
      //         id="followUp"
      //         defaultChecked={true}
      //         class="follow-up-input"
      //         onChange={ev => this.handleFollowUp(ev)}
      //       />
      //       <label htmlFor="followUp">{this.followUpLabel}</label>
      //       <svg
      //         onClick={() => this.followUpElem.click()}
      //         class="custom-svg-checkbox
      //           peer-checked:block text-white"
      //         xmlns="http://www.w3.org/2000/svg"
      //         viewBox="0 0 24 24"
      //         fill="none"
      //         stroke="currentColor"
      //         stroke-width="4"
      //         stroke-linecap="round"
      //         stroke-linejoin="round"
      //       >
      //         <polyline points="20 6 9 17 4 12"></polyline>
      //       </svg>
      //     </div>
      //   )}
      // </form>

      <form class="w-full flex flex-col gap-1.5 sticky" onSubmit={this.handleFormSubmit}>
        <div
          class={`flex-1 flex flex-col relative w-full rounded-3xl px-1 ${this.componentType === "inline" ? "inline-searchbar-bgcolor" : "searchbar-bgcolor"}`}
          dir="LTR"
          ref={el => (this.searchFormElem = el)}
        >
          {/* {this.isImage && ( */}
          {/* <div class="flex flex-wrap gap-2 mx-1 mt-2.5 mb-1`"> */}
          {/* <div id="previewContainer" draggable></div> */}
          {/* </div> */}
          {/* )} */}

          <div class="flex">
            <div class="ml-1 self-center flex space-x-1">
              {!this.hideAllButtons && (
                <div class="relative inline-block" style={{ width: "5%" }}>
                  <button
                    class="plus-icon"
                    onClick={e => {
                      e.stopPropagation()
                      this.toggleBox(e)
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="20" height="20">
                      <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"></path>
                    </svg>
                  </button>

                  {/* Option Box */}
                  <div
                    class={`absolute left-0 w-48 bg-white rounded-lg shadow-lg transition-all duration-300 ease-in-out z-10
            ${this.isOpen ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-90 pointer-events-none"}`}
                    ref={el => (this.menuElem = el as HTMLElement)}
                  >
                    <ul class="space-y-2">
                      {this.isImageUpload && (
                        <li
                          class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                          onClick={() => {
                            this.uploadElem.click()
                            this.isOpen = false
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            name="files[]"
                            id="fileInput"
                            accept="image/*"
                            class="image-upload__input"
                            onChange={($event: any) => {
                              // this.isImage = true
                              this.onInputChange($event.target.files)
                            }}
                            ref={el => (this.uploadElem = el as HTMLInputElement)}
                          />
                          <div class="mr-1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 shrink-0">
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M18.0322 5.02393C17.7488 5.00078 17.3766 5 16.8 5H11.5002C11.3 6 11.0989 6.91141 10.8903 7.85409C10.7588 8.44955 10.6432 8.97304 10.3675 9.41399C10.1262 9.80009 9.80009 10.1262 9.41399 10.3675C8.97304 10.6432 8.44955 10.7588 7.85409 10.8903C7.81276 10.8994 7.77108 10.9086 7.72906 10.9179L5.21693 11.4762C5.1442 11.4924 5.07155 11.5001 5 11.5002V16.8C5 17.3766 5.00078 17.7488 5.02393 18.0322C5.04612 18.3038 5.0838 18.4045 5.109 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.59546 18.9162 5.69617 18.9539 5.96784 18.9761C6.25118 18.9992 6.62345 19 7.2 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H7.16144C6.6343 21 6.17954 21 5.80497 20.9694C5.40963 20.9371 5.01641 20.8658 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3.13419 18.9836 3.06287 18.5904 3.03057 18.195C2.99997 17.8205 2.99998 17.3657 3 16.8385L3 11C3 8.92477 4.02755 6.93324 5.4804 5.4804C6.93324 4.02755 8.92477 3 11 3L16.8385 3C17.3657 2.99998 17.8205 2.99997 18.195 3.03057C18.5904 3.06287 18.9836 3.13419 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C20.8658 5.01641 20.9371 5.40963 20.9694 5.80497C21 6.17954 21 6.6343 21 7.16144V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V7.2C19 6.62345 18.9992 6.25118 18.9761 5.96784C18.9539 5.69617 18.9162 5.59546 18.891 5.54601C18.7951 5.35785 18.6422 5.20487 18.454 5.109C18.4045 5.0838 18.3038 5.04612 18.0322 5.02393ZM5.28014 9.41336L7.2952 8.96556C8.08861 8.78925 8.24308 8.74089 8.35381 8.67166C8.48251 8.59121 8.59121 8.48251 8.67166 8.35381C8.74089 8.24308 8.78925 8.08861 8.96556 7.2952L9.41336 5.28014C8.51014 5.59289 7.63524 6.15398 6.89461 6.89461C6.15398 7.63524 5.59289 8.51014 5.28014 9.41336ZM17 15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </div>
                          <div>Upload Images</div>
                        </li>
                      )}
                      <li
                        class="px-4 pb-2 hover:bg-gray-100 cursor-pointer flex"
                        onClick={e => {
                          this.captureScreen()
                          this.toggleBox(e)
                        }}
                      >
                        <div class="mr-1 mt-px">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                            <path d="M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z"></path>
                            <path
                              fill-rule="evenodd"
                              d="M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </div>
                        <div>Capture</div>
                      </li>
                      <li
                        class="px-4 pb-2 hover:bg-gray-100 cursor-pointer flex"
                        onClick={e => {
                          // const escapeEvent = new KeyboardEvent("keydown", { key: "Escape" })
                          // document.dispatchEvent(escapeEvent)
                          this.handleFollowUp(e)
                          this.toggleBox(e)
                        }}
                      >
                        <div class="mr-1 mt-px">
                          <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52" width="20" height="20">
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <g>
                                {" "}
                                <path d="M24.6,40.6c0-8.8,7.2-16,16-16c1.5,0,2.9,0.2,4.2,0.6c0.2-1.1,0.3-2.1,0.3-3.2c-0.1-11-9.7-19.8-21.5-19.8 c-11.9,0-21.4,8.8-21.4,19.6c0,3.4,1,6.6,2.6,9.5c0.3,0.4,0.4,1,0.2,1.5l-2.8,7.6c-0.3,0.7,0.4,1.3,1.2,1.2l7.7-3 c0.4-0.2,1-0.1,1.5,0.2c3.2,1.8,7.1,2.9,11.2,2.9c0.3,0,0.5,0,0.8,0C24.6,41.3,24.6,40.9,24.6,40.6z M34.4,18.3 c2,0,3.6,1.6,3.6,3.6s-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6S32.4,18.3,34.4,18.3z M12.9,25.4c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6 c2,0,3.6,1.6,3.6,3.6S14.8,25.4,12.9,25.4z M23.6,25.4c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6c2,0,3.6,1.6,3.6,3.6 S25.6,25.4,23.6,25.4z"></path>{" "}
                              </g>{" "}
                              <path d="M31.7,34.6l6,6l-6,6c-0.6,0.6-0.6,1.6,0,2.1l0.7,0.7c0.6,0.6,1.6,0.6,2.1,0l6-6l6,6c0.6,0.6,1.6,0.6,2.1,0 l0.7-0.7c0.6-0.6,0.6-1.6,0-2.1l-6-6l6-6c0.6-0.6,0.6-1.6,0-2.1l-0.7-0.7c-0.6-0.6-1.6-0.6-2.1,0l-6,6l-6-6c-0.6-0.6-1.6-0.6-2.1,0 l-0.7,0.7C31.2,33,31.2,34,31.7,34.6z"></path>{" "}
                            </g>
                          </svg>
                        </div>
                        <div>Clear Conversation</div>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
            {!this.hideAllButtons && (
              <div class="scrollbar-hidden text-left bg-transparent dark:text-gray-100 outline-none w-full pt-1.5 px-1 rounded-xl resize-none h-fit max-h-80 overflow-auto">
                <div class="relative w-full min-w-full h-full min-h-fit input-prose">
                  <div id="previewContainer" draggable></div>
                  <textarea
                    readOnly={this.submitted}
                    id="searchInput"
                    ref={el => {
                      this.searchInputElem = el as HTMLTextAreaElement
                      el?.focus()
                    }}
                    placeholder={this.placeholder}
                    autoComplete="off"
                    class="custom-input w-full"
                    // style={{ width: this.customWidth }}
                    value={this.searchInput}
                    rows={1}
                    onInput={debounce(e => this.handleInputChange(e), 500)}
                    onKeyUp={this.adjustHeight}
                    onKeyDown={this.handleKeyDown}
                    onFocus={() => this.searchFormElem.classList.add("input-focus-color")}
                    onBlur={() => this.searchFormElem.classList.remove("input-focus-color")}
                  ></textarea>
                  {/* <div contenteditable="true" role="textbox" id="chat-input" class="tiptap ProseMirror" tabindex="-1">
                  <p>the </p>
                </div> */}
                </div>
              </div>
            )}
            <div class="self-end mb-1.5 flex space-x-1 mr-1 flex-row" style={{ width: this.hideAllButtons ? "100%" : "auto" }}>
              <div aria-label="Record voice" class="flex self-center" style={{ width: this.hideAllButtons ? "100%" : "auto" }}>
                {this.isEnableMic && (
                  <audio-recorder
                    component-type="search"
                    onStartRecord={_ev => {
                      // console.log("test", ev)
                      this.hideAllButtons = true
                    }}
                    onStopRecord={_ev => {
                      this.hideAllButtons = false
                    }}
                    onSendTranscript={ev => {
                      console.log("ev", ev)

                      setTimeout(() => {
                        console.log("input", this.searchInputElem)
                        if (this.searchInputElem) {
                          this.searchInputElem.value = ev.detail
                          this.searchInputElem.focus()
                          // Wait for DOM to update
                          requestAnimationFrame(() => {
                            this.adjustHeight()
                          })
                        }
                      }, 1000)
                    }}
                    style={{ width: "100%" }}
                  ></audio-recorder>
                )}
              </div>{" "}
              {!this.hideAllButtons && (
                <div class="flex items-center">
                  <div aria-label="Send message" class="flex">
                    <button
                      id="send-message-button"
                      class="btn-bg-color text-white transition rounded-full p-1.5 self-center"
                      // type="submit"
                      disabled={this.submitted}
                      onClick={this.handleAskAI}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-6">
                        <path
                          fill-rule="evenodd"
                          d="M8 14a.75.75 0 0 1-.75-.75V4.56L4.03 7.78a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.75 4.56v8.69A.75.75 0 0 1 8 14Z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div class="flex">
          {this.showErrorMessage && <p class="error-msg">You can upload a maximum of 10 images once at a time.</p>}
          {/* {this.isChat && (
            <div class="follow-up">
              <input
                ref={el => (this.followUpElem = el as HTMLInputElement)}
                type="checkbox"
                name="followUp"
                id="followUp"
                defaultChecked={true}
                class="follow-up-input"
                onChange={ev => this.handleFollowUp(ev)}
              />
              <label htmlFor="followUp">{this.followUpLabel}</label>
              <svg
                onClick={() => this.followUpElem.click()}
                class="custom-svg-checkbox
                peer-checked:block text-white"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
          )} */}
        </div>
      </form>
    )
  }
}
